import {
  LayoutDashboard,
  CalendarCheck,
  PackageOpen,
  UserCircle,
  Warehouse,
  FileBarChart,
  QrCode,
  Search,
  Building2,
  Shield,
} from "lucide-react";

export interface NavItem {
  icon: React.ElementType;
  label: string;
  path: string;
  key: string;
  adminOnly?: boolean;
  systemOnly?: boolean;
  action?: "search";
}

export const SEARCH_NAV_PATH = "__search__";

export const allNavItems: NavItem[] = [
  { icon: LayoutDashboard, label: "Dashboard", path: "/dashboard", key: "dashboard" },
  { icon: CalendarCheck, label: "Bokningar", path: "/bookings", key: "bookings" },
  { icon: PackageOpen, label: "Däck", path: "/tires", key: "tires" },
  { icon: UserCircle, label: "Kunder", path: "/customers", key: "customers" },
  { icon: Warehouse, label: "Lager", path: "/storage", key: "storage" },
  { icon: FileBarChart, label: "Rapporter", path: "/reports", key: "reports" },
  { icon: QrCode, label: "Skanna", path: "/scanner", key: "scanner" },
  { icon: Search, label: "Sök", path: SEARCH_NAV_PATH, key: "search", action: "search" },
  { icon: Building2, label: "Företag", path: "/companies", key: "companies", adminOnly: true },
  { icon: Shield, label: "Admin", path: "/admin", key: "admin", adminOnly: true, systemOnly: false },
];

export const DEFAULT_PRIMARY_PATHS = ["/dashboard", "/bookings", "/scanner", SEARCH_NAV_PATH];
export const LONG_PRESS_MS = 3000;
export const STORAGE_KEY = "tv_nav_primary_paths";
